import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { DashWrapper } from "components/DashboardContainer/UnauthenticatedDash";
import HtmlRenderer from "./HtmlRenderer";
import { useHistory } from "react-router-dom";
import { useKas } from "contexts/KasContext";
interface RouteParams {
  notebook: string;
}

const NotebookRenderer: React.FC = () => {
  const { notebook } = useParams<RouteParams>();
  const { isUserLoggedIn, user } = useKas();
  const history = useHistory();
  const [callBackUrl, setCallBackUrl] = useState("/instance/new");
  const [noteBookNotFound, setNoteBookNotFound] = useState(false);

  useEffect(() => {
    const navigationEntries = window.performance.getEntriesByType(
      "navigation"
    ) as PerformanceNavigationTiming[];
    if (
      navigationEntries.length > 0 &&
      navigationEntries[0].type === "reload"
    ) {
      history.push(`/notebook/${notebook}`);
    }
  }, []);

  useEffect(() => {
    if (isUserLoggedIn && user?.email) {
      history.push(`/notebooks/${notebook}`);
    }
  }, [isUserLoggedIn, user]);

  const handleNavigation = (url: string) => {
    history.push(url);
  };

  return (
    // This works because App.tsx has the unauthenticated route outside of the Dash, which requires auth.
    <DashWrapper callbackUrl={callBackUrl} notebookNotFound={noteBookNotFound}>
      <div className="min-h-full">
        <header className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <HtmlRenderer
            notebook={notebook}
            setCallbackUrl={setCallBackUrl}
            setNoteBookNotFound={setNoteBookNotFound}
            onNavigate={handleNavigation}
          />
        </header>
      </div>
    </DashWrapper>
  );
};

export default NotebookRenderer;
